type Props = {
  value: number | null;
  onChange?: (next: number | null) => void;
  size?: number;
};

/** Renders a 1-5 bookmark rating. Read-only if no onChange is provided. */
export default function BookmarkRating({ value, onChange, size = 18 }: Props) {
  const interactive = typeof onChange === "function";
  return (
    <div
      role={interactive ? "radiogroup" : undefined}
      aria-label="Club rating"
      style={{ display: "inline-flex", gap: 4, alignItems: "center" }}
    >
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = (value ?? 0) >= n;
        const Comp = interactive ? "button" : "span";
        return (
          <Comp
            key={n}
            {...(interactive
              ? {
                  type: "button" as const,
                  role: "radio",
                  "aria-checked": value === n,
                  "aria-label": `${n} of 5`,
                  onClick: () => onChange!(value === n ? null : n),
                  style: { background: "none", padding: 0, cursor: "pointer" },
                }
              : { "aria-hidden": "true" })}
          >
            <svg
              viewBox="0 0 24 24"
              width={size}
              height={size}
              focusable="false"
              aria-hidden={!interactive}
            >
              <path
                d="M7 3h10a1 1 0 0 1 1 1v17l-6-3-6 3V4a1 1 0 0 1 1-1z"
                fill={filled ? "var(--c-coral)" : "transparent"}
                stroke={filled ? "var(--c-coral)" : "var(--c-rule)"}
                strokeWidth="1.6"
              />
            </svg>
          </Comp>
        );
      })}
    </div>
  );
}
